import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Api } from "../../../BackendApi/api";
import "../CustomerOverlay.css";
import ConfirmPopup from "../../../Component/ConfirmPopup/ConfirmPopup";
import CoinAllotmentOverlay from "../../CoinsAllotments/CoinAllotmentOverlay";

const EditCustomerOverlay = ({ customer, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    custName: "",
    Custmobile: "",
    address: "",
    reference: "",
    location: "",
    status: "ACTIVE",
  });

  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [showCoinOverlay, setShowCoinOverlay] = useState(false);
  const nameInputRef = useRef(null);

  // ✅ Prefill customer data
  useEffect(() => {
    if (customer) {
      setFormData({
        custName: customer.customerName || "",
        Custmobile: customer.mobile || "",
        address: customer.address || "",
        location: customer.mapLocation
          ? `${customer.mapLocation.lat}, ${customer.mapLocation.lng}`
          : "",
        reference: customer.reference || "",
        status: customer.status === "ACTIVE" ? "ACTIVE" : "DEACTIVE",
      });
    }

    nameInputRef.current?.focus();
  }, [customer]);

  // ✅ Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ Open Coin Overlay
  const handleAddCoin = () => {
    setShowCoinOverlay(true);
  };

  // ✅ Submit customer update
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!customer?.id) {
      alert("Customer ID missing");
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      setLoading(true);

      const payload = {
        _id: customer.id,
        CustName: formData.custName,
        CustMobile: formData.Custmobile,
        CustAddress: formData.address,
        CustLocation: formData.location,
        Reference: formData.reference,
        Status: formData.status,
      };

      const res = await axios.post(Api.editCustomer, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status === 200) {
        setPopup({
          show: true,
          message: "Customer updated successfully",
          type: "success",
        });
      }
    } catch (err) {
      setPopup({
        show: true,
        message: "Update failed",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      onSave?.();
      onClose();
    }
  };

  return (
    <>
      <div className="overlay">
        <div className="overlay-content">
          <h2>Edit Customer</h2>

          <form className="overlay-form" onSubmit={handleSubmit}>
            {/* ✅ Name + Add Coin */}
            <label className="custname-label">
              Customer Name
              <div className="admin-custname-row">
                <input
                  ref={nameInputRef}
                  type="text"
                  name="custName"
                  value={formData.custName}
                  onChange={handleChange}
                  required
                />

                <button
                  type="button"
                  className="admin-add-coin-btn"
                  onClick={handleAddCoin}
                >
                  + Add Coin
                </button>
              </div>
            </label>

            <label>
              Mobile
              <input
                type="text"
                name="Custmobile"
                value={formData.Custmobile}
                onChange={handleChange}
              />
            </label>

            <label>
              Reference
              <input
                type="text"
                name="reference"
                value={formData.reference}
                onChange={handleChange}
              />
            </label>

            <label>
              Location
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
            </label>

            <label>
              Address
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </label>

            <label>
              Status
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="ACTIVE">Active</option>
                <option value="DEACTIVE">DeActive</option>
              </select>
            </label>

            <div className="overlay-buttons">
              <button type="button" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" disabled={loading}>
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>

        <ConfirmPopup
          show={popup.show}
          message={popup.message}
          type={popup.type}
          onClose={handlePopupClose}
        />
      </div>

      {/* 🔥 COIN ALLOTMENT OVERLAY WITH CUSTOMER DATA */}
      {showCoinOverlay && (
        <CoinAllotmentOverlay
          customerData={{
            name: formData.custName,
            id: customer.id,
          }}
          onClose={() => setShowCoinOverlay(false)}
          onSave={() => {
            setShowCoinOverlay(false);
            onSave?.();
          }}
        />
      )}
    </>
  );
};

export default EditCustomerOverlay;
